import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { sectionSubjectUpdate } from 'sdk';

import { notifyErrors, notifySuccess } from 'utils/notifications';

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    minWidth: 240,
    width: '100%'
  }
}));

const SubjectDialog = ({
  onClose,
  initialSubject = '',
  sectionId,
  onSuccess
}) => {
  const classes = useStyles();
  const [subject, setSubject] = React.useState(initialSubject);

  const handleChange = (event) => {
    setSubject(event.target.value);
  };

  const onConfirm = async () => {
    const { success, errors } = await sectionSubjectUpdate({
      sectionId,
      data: { subject_name: subject }
    });

    if (success) {
      notifySuccess('Subject updated successfully');
      onSuccess();
      onClose();
    } else {
      notifyErrors(errors);
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      aria-labelledby="subject-dialog-title"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="subject-dialog-title">Change Subject</DialogTitle>

      <DialogContent>
        <FormControl className={classes.formControl}>
          <InputLabel id="subject-select-label">Select Subject</InputLabel>
          <Select
            labelId="subject-select-label"
            id="subject-select"
            value={subject}
            onChange={handleChange}
          >
            {!['Math', 'ELA', 'Homeroom', 'other'].includes(initialSubject) && (
              <MenuItem value={initialSubject}>{initialSubject}</MenuItem>
            )}
            <MenuItem value="Math">Math</MenuItem>
            <MenuItem value="ELA">ELA</MenuItem>
            <MenuItem value="Homeroom">Homeroom</MenuItem>
            <MenuItem value="other">other</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={!subject}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubjectDialog;
